export function isValidSlovakPhoneNumber(phone) {
    const slovakPhoneRegex = /^(?:\+421|0)([9]{1}[0-9]{8})$/;
    return slovakPhoneRegex.test(phone);
}